export default {
  route: {
    dashboard: 'Dashboard',
    documentation: 'Documentation',
    guide: 'Guide',
    market: 'Market',
    users: 'Users',
    buyers: 'Buyers',
    wholesalers: 'Wholesalers',
    sellers: 'Sellers',
    caretakers: 'Caretakers',
    orders: 'Orders',
    customerOrders: 'Customer Orders',
    orderEdit: 'Order Edit',
    giftCards: 'Gift Cards',
    giftCardEdit: 'Gift Card edit',
    giftCardCreate: 'Gift Card create',
    ursafEvents: 'URSSAF Events',
    ursafEventEdit: 'URSSAF Event edit',
    ursafEventCreate: 'URSSAF Event create',
    countriesAndRegions: 'Countries & Regions',
    countryEdit: 'Country Edit',
    countryCreate: 'Country Create',
    regionEdit: 'Region Edit',
    regionCreate: 'Region Create',
    rateCards: 'Rate Cards',
    cardPricing: 'Card Pricing',
    rates: 'Rates',
    cards: 'Cards',
    purchaseInfos: 'Purchase Infos',
    purchaseInfosEdit: 'Purchase Info Edit',
    purchaseInfosCreate: 'Purchase Info Create',
    giftCardSellers: 'GiftCard Sellers',
    customers: 'Customers',
    advertisers: 'Advertisers',
    wallet: 'Wallet',
    sorewards: 'Sorewards',
    sorewardsPrograms: 'Programs',
    sorewardsProgramCreate: 'Create Sorewards program',
    sorewardsProgramShow: 'Sorewards program',
    sorewardsSettings: 'Settings',
    sorewardsLoadTransactions: 'Load transactions',
    sorewardsIssueTransactions: 'Issuance transactions',
    categories: 'Categories',
    skus: 'Skus',
    skuEdit: 'Sku edit',
    skuCreate: 'Sku create',
    deliveries: 'Deliveries',
    paymentModes: 'Payment Modes',
    invoices: 'Invoices',
    invoiceEdit: 'Invoice Edit',
    bankTransfers: 'Bank Transfers',
    balances: 'Balances',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    rolePermission: 'Role Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: 'Mixin',
    backToTop: 'Back To Top',
    draggableDialog: 'Draggable Dialog',
    draggableKanban: 'Draggable Kanban',
    draggableList: 'Draggable List',
    draggableSelect: 'Draggable Select',
    charts: 'Charts',
    barChart: 'Bar Chart',
    lineChart: 'Line Chart',
    mixedChart: 'Mixed Chart',
    example: 'Example',
    nested: 'Nested Routes',
    menu1: 'Menu 1',
    'menu1-1': 'Menu 1-1',
    'menu1-2': 'Menu 1-2',
    'menu1-2-1': 'Menu 1-2-1',
    'menu1-2-2': 'Menu 1-2-2',
    'menu1-3': 'Menu 1-3',
    menu2: 'Menu 2',
    table: 'Table',
    dynamicTable: 'Dynamic Table',
    draggableTable: 'Draggable Table',
    inlineEditTable: 'Inline Edit Table',
    complexTable: 'Complex Table',
    tab: 'Tab',
    form: 'Form',
    createArticle: 'Create Article',
    editArticle: 'Edit Article',
    articleList: 'Article List',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    mergeHeader: 'Merge Header',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboard: 'Clipboard',
    i18n: 'I18n',
    externalLink: 'External Link',
    profile: 'Profile',
    browseAndGo: 'Operation and programme models',
    browseAndGoMenu: 'Models',
    bngOverview: 'Overview',
    bngUrssaf: 'URSSAF operation models',
    bngUrssafMenu: 'URSSAF',
    bngOther: 'Other operation models',
    bngOtherMenu: 'Other operations',
    bngCards: 'Multi-choice card models',
    bngCardsMenu: 'Multi-choice cards',
    bngCardEdit: 'Edit a multi-choice card model',
    bngCardCreate: 'Create a multi-choice card model',
    bngBenefits: 'Benefits programme models',
    bngBenefitsMenu: 'Benefits',
    bngBenefitEdit: 'Edit a benefits programme model',
    bngBenefitCreate: 'Create a benefits programme model',
    bngSelections: 'Merchant selections',
    bngSelectionsMenu: 'Selections',
    bngSelectionEdit: 'Edit a merchant selection',
    bngSelectionCreate: 'Create a merchant selection',
    bngAssignments: 'Assignments',
    bngOperationEdit: 'Edit an operation model',
    bngOperationCreate: 'Create an operation model'
  },
  order: {
    title: 'Buyer orders',
    bulk: 'Group orders',
    invoice: 'Supplier invoice(s)'
  },
  invoice: {
    title: 'Buyer invoice(s)',
    bulk: 'Supplier invoice(s)'
  },
  ursafEvents: {
    empty: 'No URSSAF events',
    activeYes: 'Active',
    activeNo: 'Inactive',
    fields: {
      code: 'Code',
      name: 'Name',
      cseKind: 'CSE kind',
      defaultDotationDuration: 'Default dotation duration',
      active: 'Active',
      multiChoiceGiftCard: 'Multi-choice gift card',
      createdAt: 'Created at',
      updatedAt: 'Updated at'
    },
    filters: {
      name: 'Name',
      active: 'Status'
    },
    placeholders: {
      code: 'E.g. christmas',
      name: 'E.g. Christmas',
      cseKind: 'Select a CSE kind',
      defaultDotationDuration: 'E.g. P1Y',
      multiChoiceGiftCard: 'Search a multi-choice gift card'
    },
    cseKinds: {
      no_cse: 'No CSE',
      social_cse: 'Social CSE',
      budget_cse: 'Budget CSE'
    },
    validation: {
      code: 'Code is required',
      name: 'Name is required',
      cseKind: 'CSE kind is required',
      multiChoiceGiftCard: 'Multi-choice gift card is required'
    },
    form: {
      createTitle: 'Create URSSAF event',
      editTitle: 'URSSAF event — {name}',
      create: 'Create',
      update: 'Update',
      back: 'Back'
    },
    notifications: {
      createdTitle: 'URSSAF event created',
      createdMessage: 'The URSSAF event was created successfully',
      updatedTitle: 'URSSAF event updated',
      updatedMessage: 'The URSSAF event was updated successfully'
    }
  },
  sorewardsPrograms: {
    empty: 'No Sorewards programs',
    fields: {
      name: 'Name',
      programType: 'Type',
      sorewardsProgramId: 'Sorewards program ID',
      createdAt: 'Created at',
      updatedAt: 'Updated at'
    },
    filters: {
      name: 'Name'
    },
    placeholders: {
      name: 'E.g. Christmas program 2026',
      programType: 'Select a program type'
    },
    families: {
      PROFID: 'Loyalty bonus',
      CHCOMA: 'Sales challenge',
      PARRAI: 'Referral',
      INCINT: 'Incentive',
      OEUSOC: 'Social works',
      CE: 'Works council',
      NOELA: 'Christmas',
      NOELE: 'Christmas (children)',
      RETR: 'Retirement',
      FETPAR: 'Parents’ day',
      MARPAC: 'Wedding / civil union',
      CV: 'Holiday vouchers',
      SCO: 'Back to school',
      NAIS: 'Birth',
      CC: 'Gift vouchers',
      FL: 'Flowers',
      AUTRES: 'Other',
      TOP_UP: 'Top-up'
    },
    validation: {
      name: 'Name is required',
      programType: 'Program type is required'
    },
    form: {
      createTitle: 'Create a Sorewards program',
      showTitle: 'Sorewards program — {name}',
      create: 'Create',
      back: 'Back',
      creatingHint: 'Creation calls Sorewards and may take a few seconds'
    },
    notifications: {
      createdTitle: 'Sorewards program created',
      createdMessage: 'The Sorewards program was created successfully'
    }
  },
  sorewardsConsole: {
    tabs: {
      standard: 'Standard rates',
      negotiated: 'Negotiated rates',
      programs: 'Programmes'
    },
    stdTitle: 'Standard rates',
    stdDesc: 'Grid applied by default to any caretaker without a specific agreement. Amounts excluding tax, in euros.',
    issuance: 'Card issuance',
    shipping: 'Shipping',
    loading: 'Loading',
    physCard: 'Physical card',
    virtCard: 'Virtual card',
    shipUnit: 'Single shipment',
    shipGroup: 'Grouped shipment',
    loadFee: 'Flat fee per load',
    loadPct: 'Commission on loaded amount',
    perCard: 'per card',
    perParcel: 'per parcel',
    perLoad: 'per load',
    ofAmount: 'of amount',
    groupNote: 'from 25 cards shipped to a single address',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    saved: 'Rates saved',
    negoTitle: 'Negotiated rates',
    negoDesc: 'Specific grid applied to a caretaker in place of the standard rates, over the agreed period.',
    addNego: 'Add an agreement',
    caretaker: 'Caretaker',
    validUntil: 'Valid until',
    noNego: 'No negotiated rates',
    noNegoSub: 'Add an agreement to apply a specific grid to a caretaker.',
    deleteConfirm: 'Delete this rate agreement?',
    caretakerRequired: 'Caretaker is required',
    validUntilRequired: 'End date is required',
    progTitle: 'Sorewards programmes and Privipass mapping',
    progDesc: 'Each Sorewards programme family maps to a Privipass code that sets which spending categories the card opens.',
    progName: 'Sorewards programme',
    privipass: 'Privipass code',
    allowedType: 'Allocation type',
    ceiling: 'Tax-free ceiling',
    validity: 'Validity',
    status: 'Status',
    months: 'months',
    active: 'Active',
    draft: 'Draft',
    progPending: 'The Privipass mapping is still to be confirmed by the issuer. The codes below are provisional.',
    filters: 'Filters',
    reset: 'Reset',
    exportCsv: 'Export to CSV',
    dateFrom: 'From',
    dateTo: 'To',
    allCaretakers: 'All caretakers',
    searchCaretaker: 'Search a caretaker',
    rowsOf: '{count} row of {total} | {count} rows of {total}',
    totalLoaded: 'Loaded amount',
    totalRemaining: 'Remaining balance',
    cardsCount: 'Cards involved',
    totalLoadCost: 'Loading cost',
    totalIssueCost: 'Issuance cost',
    cardsIssued: 'Cards issued',
    physCount: 'Physical',
    virtCount: 'Virtual',
    noResults: 'No transactions',
    noResultsSub: 'No row matches the filters. Widen the period or clear a criterion.',
    idDistribution: 'Distribution id',
    operation: 'Operation',
    dotationOrder: 'Allocation order',
    program: 'Programme',
    dotationType: 'Allocation type',
    dotationDate: 'Allocation issued',
    loadDate: 'Load date',
    loadRef: 'Load order ref.',
    expiry: 'Expiry',
    amount: 'Amount',
    beneficiary: 'Beneficiary',
    cardId: 'Card id',
    remaining: 'Remaining balance',
    loadCost: 'Loading cost',
    issuePrice: 'Issuance price',
    coverLoad: 'Coverage',
    coverIssue: 'Coverage',
    issueDate: 'Card issued',
    cardNumber: 'Card number',
    cardType: 'Card type',
    multi: 'Multi',
    mono: 'Mono',
    physical: 'Physical',
    virtual: 'Virtual',
    caretakerShare: 'caretaker share',
    negoLegend: 'The brass dot marks an amount computed on a negotiated rate.',
    stdApplied: 'Standard rate',
    negoApplied: 'Negotiated rate',
    loadTitle: 'Load transactions',
    issueTitle: 'Issuance transactions',
    operations: {
      NOELA: 'Christmas 2025 — Employees',
      SCO: 'Back to school 2026',
      NAIS: 'Births Q1 2026',
      MARPAC: 'Weddings 2026',
      CV: 'Summer holiday vouchers',
      RETR: 'Retirements 2026'
    }
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    github: 'Github',
    theme: 'Theme',
    size: 'Global Size',
    profile: 'Profile'
  },
  login: {
    title: 'Login Form',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  documentation: {
    documentation: 'Documentation',
    github: 'Github Repository'
  },
  permission: {
    createRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  guide: {
    description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
    button: 'Show Guide'
  },
  components: {
    documentation: 'Documentation',
    tinymceTips: 'Rich text is a core feature of the management backend, but at the same time it is a place with lots of pits. In the process of selecting rich texts, I also took a lot of detours. The common rich texts on the market have been basically used, and I finally chose Tinymce. See the more detailed rich text comparison and introduction.',
    stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
    backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
    backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
    imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.',
    changeLanguageTips: 'Switch Language Success'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    importance: 'Importance',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    reviewer: 'Reviewer',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    email: 'E-mail',
    name: 'Name',
    firstname: 'Firstname',
    lastname: 'Lastname',
    password: 'Password',
    passwordConfirmation: 'Password Confirmation',
    confirmedAt: 'Confirmed at',
    skuDiscardTooltip: 'A SKU containing stock cannot be archived',
    skuNotDiscardableTooltip: 'Once reactivated, this SKU cannot be archived anymore because it contains stock'
  },
  example: {
    warning: 'Creating and editing pages cannot be cached by keep-alive because keep-alive\'s \'include\' currently does not support caching based on routes, so now it\'s cached based on component name. If you want to achieve a similar caching effect, you can use a browser caching scheme such as localStorage. Or don\'t use keep-alive\'s \'include\' to cache all pages directly. See details'
  },
  wallet: {
    usageStatus: {
      unused: 'Unused',
      partially_used: 'Partially used',
      used: 'Used',
      archived: 'Archived'
    }
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name (default excel-list)'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name (default file)'
  },
  pdf: {
    tips: 'Here we use window.print() to implement the feature of downloading PDF.'
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    showTagsView: 'Open Tags-View',
    showSidebarLogo: 'Sidebar Logo',
    fixedHeader: 'Fixed Header',
    sidebarTextTheme: 'Sidebar Text Theme'
  }
}
